import { DEFINED_BY } from './common-kids';

export default {

	api: {
		headerTokenName: 'Knitiv-Token',
		version: '2',
	},

	apiCache: {
		MF_Autocomplete2: 300,
		MF_Children2: 300,
		MF_Suggestion2: 300,
		roleprofil: 300,
	},

	configFile: 'config.json',

	checkIntervalForNewVersion: 300,

	kform: {
		btn_record: {
			save: {
				action: 'save',
				color:  'success',
				icon:   'floppy-o',
				name:   'common.save',
			},
			submit: {
				action: 'submit',
				color:  'success',
				icon:   'check',
				name:   'common.submit',
			}
		},
	},

	requestTimeout: 10_000,

	packetSize: 5_242_880,

	DROIT: {
		NONE: 0x00,
		ALL: 0x0F,
		READ: 0x08,
		CREATE: 0x04,
		MODIFY: 0x02,
		DELETE: 0x01,
	},

	KCARDN: 999_999_999,

	maxNotifications: 10,

	query: {
		packetSize: 50,
		selectTypeNodes: [
			{ id: 'ENABLED', group: 'info' },
			{ id: 'REPRE', group: 'repre' },
			{ id: 'KID', group: 'info' },
			{ id: 'ISA', group: 'info' },
			{ id: 'ISA_KID', group: 'info' },
			{ id: 'KDATECREATION', group: 'info' },
			{ id: 'KDATED', group: 'info' },
			{ id: 'KDATEF', group: 'info' },
			{ id: 'FILE', group: 'info' },
			{ id: 'MIMETYPE', group: 'info' },
			{ id: 'URL_PREVIEW', group: 'info' },
			{ id: 'REF_PROPRI', group: 'info' },
			{ id: 'KRIGHT', group: 'info' },
		],
		selectTypeNodesAttributes: [
			'F_SIZE',
			'F_EXTENSION',
			'F_FILENAME',
			'F_MIMETYPE',
			'F_VERSION',
		],
	},

	schema: {
		DEFAULT_CARD_FROM: 0,
		DEFAULT_CARD_TO: 1,
		/** @type {import('@knitiv/api-client-javascript').KNode} */
		DEFAULT_RELATION: DEFINED_BY,
	},

	security: {
		argon2: {
			ITERATIONS_NB: 3,
			MEMORY_USED:   65_512,
			PARALLELISM:   2,
		},
	},

	viewerEnginesMimetypes: {
		html: /text\/html/,
		image: /image\/.+/,
		json: /application\/json/,
		pdf: /application\/pdf/,
		text: /text\/(?!html)/,
		video: /video\/.+/,
	},
};
